module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@3x-d9eea4212c73db38e344bfb387a06044.png";